import { useNavigate } from 'react-router-dom'

import { LayoutPage } from '../LayoutPage'

import { useSimpleState } from '../../hooks/useSimpleState'

import './index.css'

// no captured production build ever included a real logo image (same
// reconstruction gap as icons.css — see RECONSTRUCTION_NOTES.md), so this
// mirrors the text wordmark the design mockup settled on instead: "FYC" +
// checkmark + "DEALS" in the sampled brand green, not an invented image asset
const CheckIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="4 13 9 18 20 6"></polyline>
    </svg>
)

const ManageIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
)

const CreateIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
)

const AffiliatesIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
)

const CategoriesIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
)

const HamburgerIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="4" y1="7" x2="20" y2="7"></line>
        <line x1="4" y1="12" x2="20" y2="12"></line>
        <line x1="4" y1="17" x2="20" y2="17"></line>
    </svg>
)

const NavigationBarComponent = () => {
    const navigate = useNavigate()

    const {_state} = useSimpleState({
        mobileOpen: false
    })

    const closeMobile = () => _state.set('mobileOpen', false)

    const handleClickManageDeals = () => {
        closeMobile()
        navigate('/')
    }

    const handleClickCreateDeals = () => {
        closeMobile()
        navigate('/create-deals')
    }

    const handleClickAffiliates = () => {
        closeMobile()
        navigate('/affiliates')
    }

    const handleClickCategories = () => {
        closeMobile()
        navigate('/categories')
    }

    const toggleMobile = () => {
        _state.set('mobileOpen', !_state.get('mobileOpen'))
    }

    return (
        <div className={`c-NavigationBar${_state.get('mobileOpen') ? ' is-open' : ''}`}>
            <LayoutPage>
                <div className="navigationBar-brand" onClick={handleClickManageDeals}>
                    <span className="navigationBar-brandMark">FYC<CheckIcon /></span>
                    <span className="navigationBar-brandWord">Deals</span>
                </div>

                <button
                    type="button"
                    className="navigationBar-hamburger"
                    onClick={toggleMobile}
                    aria-label="Toggle menu"
                    aria-expanded={_state.get('mobileOpen')}
                >
                    <HamburgerIcon />
                </button>

                <ul className="navigationBar-navMain">
                    <li onClick={handleClickManageDeals}><ManageIcon />Manage</li>
                    <li onClick={handleClickCreateDeals}><CreateIcon />Create</li>
                    <li onClick={handleClickAffiliates}><AffiliatesIcon />Affiliates</li>
                    <li onClick={handleClickCategories}><CategoriesIcon />Categories</li>
                </ul>
            </LayoutPage>
        </div>
    )
}

export { NavigationBarComponent }